module.exports = __webpack_public_path__ + "static/media/Keep Working On It (1).ce23706d.jpg";